module.exports = {
  baseUrl: 'http://121.204.156.143:9393/',
  projectName: '延平区科特派服务云平台',
  preViewUrl: 'http://121.204.156.143:9393',
  flowOld: 'flowSpecialistInfo:3:0d0988e7-52aa-11ed-8118-0242ac110003',
  flowNew: 'flowSpecialistInfo:8:b59fde26-8fbc-11ed-88eb-0242ac110003',
  canUpdate: true
}
